/**
 * Date utility functions
 */

/**
 * Format date to DD-MM-YYYY format
 * Handles various input formats including YYYY-MM-DD, DD-MM-YYYY, DD/MM/YYYY, etc.
 * @param {string} dateString - Date string in any format
 * @returns {string} Formatted date string in DD-MM-YYYY format
 */
export const formatDateOfBirth = (dateString) => {
  if (!dateString) return '';

  // Try to parse using Date object first (handles most formats)
  const date = new Date(dateString);
  if (!isNaN(date.getTime())) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // If Date parsing fails, try manual parsing for common formats
  const parts = dateString.split(/[-/]/);
  if (parts.length === 3) {
    // Check if first part is year (4 digits)
    if (parts[0].length === 4) {
      // YYYY-MM-DD or YYYY/MM/DD format
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    } else {
      // DD-MM-YYYY or DD/MM/YYYY format (already in correct format)
      // Ensure two-digit day and month
      const day = String(parts[0]).padStart(2, '0');
      const month = String(parts[1]).padStart(2, '0');
      const year = parts[2].length === 2 ? `20${parts[2]}` : parts[2];
      return `${day}-${month}-${year}`;
    }
  }

  // Return original string if parsing fails
  return dateString;
};
